<main class="prepurchase-list">
  <app-breadcrumb [items]="breadcrumbs" />

  <header class="prepurchase-list__hero">
    <div class="prepurchase-list__hero-icon" aria-hidden="true">
      <app-icon [icon]="calendarIcon" [size]="28" color="currentColor" />
    </div>
    <div class="prepurchase-list__hero-content">
      <h1 class="prepurchase-list__title">Precompras abiertas</h1>
      <p class="prepurchase-list__lead">
        Reserva productos antes de su lanzamiento pagando un
        <strong>30% de abono</strong>. Recibirás instrucciones por correo y
        pagarás el 70% restante cuando el producto esté disponible para ser retirado.
      </p>
    </div>
  </header>

  <section class="prepurchase-list__content">
    @if (loading()) {
      <div class="prepurchase-list__grid">
        @for (i of skeletonArray; track i) {
          <app-product-card-skeleton viewMode="grid" />
        }
      </div>
    } @else if (error()) {
      <div class="prepurchase-list__empty">
        <p class="prepurchase-list__empty-title">Algo salió mal</p>
        <p class="prepurchase-list__empty-text">{{ error() }}</p>
        <app-button variant="secondary" (click)="onRetry()">
          Reintentar
        </app-button>
      </div>
    } @else if (products().length === 0) {
      <div class="prepurchase-list__empty">
        <img
          class="prepurchase-list__empty-mascot"
          src="/images/logo/empty_cart.png"
          alt=""
          loading="lazy"
        />
        <p class="prepurchase-list__empty-title">
          No hay precompras abiertas ahora mismo
        </p>
        <p class="prepurchase-list__empty-text">
          Vuelve pronto — publicamos nuevas reservas cuando se anuncian lanzamientos.
        </p>
      </div>
    } @else {
      <div class="prepurchase-list__grid">
        @for (product of products(); track product.id) {
          <!-- Sin (addToCart) ni (notifyRequest)/(notifyCancel) a propósito: todo
               producto de este listado es isPreSale, así que la card pinta
               «Reservar» o «Precompra Agotada» y nunca «Agregar» ni la campana. -->
          <app-product-card
            [product]="product"
            viewMode="grid"
            [showEaRequirement]="true"
            (reserveClick)="onReserve($event)"
            (zoomOpen)="onZoomOpen($event)"
            (cardClick)="onCardClick($event)"
          />
        }
      </div>
    }
  </section>
</main>

@if (zoomProduct(); as zp) {
  <!-- Sin (notifyRequest) a propósito: todo producto de este listado es
       isPreSale y el modal solo pinta «Avisarme» si !isPreSale. -->
  <app-product-zoom-modal
    [product]="zp"
    (close)="onZoomClose()"
    (addToCart)="onZoomAddToCart($event)"
    (reserveRequest)="onZoomReserve($event)"
    (viewDetails)="onViewDetails($event)"
  />
}
